module.exports = __webpack_public_path__ + "img/imagem2.8084faa8.svg";